<template>
	<div>
		<form action @submit.prevent="onSubmit">

			<form-errors :errors="errors"></form-errors>

			<div class="title-container">
				<div class="title">Add User</div>
				<div class="buttons">
					<router-link to="/account/users/overview" class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
				</div>
			</div>
			<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
			<div class="input-container">
				<div class="input-title">Email Address</div>
				<div class="input-box"><input type="text" v-model="form.email" placeholder="Email Address"></div>
			</div>

			<div class="title-container">
				<div class="title">Add Authorization</div>
			</div>

			<user-authorizations-form v-model="form" :has-submitted-form="submitAttempted" :validation="$v"></user-authorizations-form>

			<submit-button text="Invite User" icon="fa-satellite" :has-errors="hasErrors" :loading="formSaving"></submit-button>

		</form>
	</div>
</template>

<script>

import { ACCESS_TYPE } from '@/constants/connections';
import { required, email } from 'vuelidate/lib/validators';
import FormMixin from '@/mixins/FormMixin';
import UserAuthorizationsForm from './forms/UserAuthorizationsForm';

export default {

	name: 'UsersCreatePage',

	mixins: [ FormMixin ],

	data() {
		return {
			ACCESS_TYPE,
			form: {
				access_type: ACCESS_TYPE.FULL,
				permissions: {
					_dashboard: true,
				},
				modules: {},
			},
		};
	},

	validations: {
		form: {
			email: { required, email },
			access_type: { required },
		},
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.post('/account/connections', this.form);

				this.$store.dispatch('addToast', 'User has been invited to manage this account');
				this.$router.push('/account/users/overview');
			});
		},

	},

	components: {
		UserAuthorizationsForm,
	},

};

</script>
